export const selectIsAnyPopupShown = (state) => !!state.popup.length;
